/***********************
 * CUSTOMERS/SERVICES TABLE
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { sortData, booleanSorter, stringSorter } from "utils/general"
//Translation
import { withTranslation } from "react-i18next"
import TableReporting from "components/Tables/TableReporting"
import { columnWidth } from "components/Tables/columns"

const TableStats = props => {
  //Excel and pdf name
  const title = props.t("Customers and services")
  const titleExport = props.t("Services")
  //Table data state
  const [series, setSeries] = useState([])
  const [origSeries, setOrigSeries] = useState([])
  //Filtered data
  const [filteredData, setFilteredData] = useState(series)
  const [handleValue, setHandleValue] = useState("")
  const [loading, setLoading] = useState(true)

  //Setting data state
  useEffect(() => {
    console.log("Data table: " + JSON.stringify(props.data.array))
    let sorted = sortData(props.data.array)
    setOrigSeries(sorted)
    setSeries(sorted)
    setLoading(false)
  }, [props.data])

  useEffect(() => {
    // console.log("entries filtered", series)
    if (series != undefined) {
      setFilteredData(series)
      if (handleValue != "") {
        handlingInput(handleValue)
      }
    }
  }, [series])

  const columns = [
    {
      dataIndex: "group",
      title: props.t("Group"),
      sorter: (a, b) => {
        return stringSorter(a, b, "group")
      },
      width: columnWidth.group,
    },
    {
      dataIndex: "name",
      title: props.t("Name"),
      sorter: (a, b) => {
        return stringSorter(a, b, "name")
      },
      width: columnWidth.nameWide,
    },
    {
      dataIndex: "tags",
      title: props.t("Tags"),
      render: (cell, row) => {
        if (!cell || cell.length === 0) return ""
        return cell.join(", ")
      },
      ellipsis: true,
      width: columnWidth.group,
    },
    {
      dataIndex: "home",
      title: props.t("Home"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "home")
      },
      render: (cell, row) => statusFormatter(cell, row.home_inactive),
      width: columnWidth.medium,
      inActive: false,
    },
    {
      dataIndex: "tracker",
      title: props.t("On the Go"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "tracker")
      },
      render: (cell, row) => statusFormatter(cell, row.tracker_inactive),
      width: columnWidth.medium,
      inActive: true,
    },
    {
      dataIndex: "carephone",
      title: props.t("Safety phone"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "carephone")
      },
      render: (cell, row) => statusFormatter(cell, row.carephone_inactive),
      width: columnWidth.medium,
    },
    {
      dataIndex: "video",
      title: props.t("Video"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "video")
      },
      render: (cell, row) => statusFormatter(cell, row.video_inactive),
      width: columnWidth.medium,
    },
    {
      dataIndex: "health",
      title: props.t("Measurements"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "health")
      },
      render: (cell, row) => statusFormatter(cell, row.health_inactive),
      width: columnWidth.medium,
    },
    /*{
      dataIndex: "dose",
      title: props.t("Medication reminder"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "dose")
      },
      render: (cell, row) => statusFormatter(cell, row.dose_inactive),
      width: columnWidth.medium,
    },*/
    {
      dataIndex: "smartlock",
      title: props.t("Smartlock"),
      sorter: (a, b) => {
        return booleanSorter(a, b, "smartlock")
      },
      render: (cell, row) => statusFormatter(cell, row.smartlock_inactive),
      width: columnWidth.medium,
    },
  ]

  // Export values
  const pdfHeading = [
    props.t("Group"),
    props.t("Name"),
    props.t("Tags"),
    props.t("Home"),
    props.t("On the Go"),
    props.t("Safety phone"),
    props.t("Video"),
    props.t("Measurements"),
    //props.t("Medication reminder"),
    props.t("Smartlock"),
  ]
  const pdfData = filteredData.map(elt => [
    elt.group,
    elt.name,
    elt.tags,
    statusFormatterExport(elt.home),
    statusFormatterExport(elt.tracker),
    statusFormatterExport(elt.carephone),
    statusFormatterExport(elt.video),
    statusFormatterExport(elt.health),
    //statusFormatterExport(elt.dose),
    statusFormatterExport(elt.smartlock),
  ])

  const xlsxHeading = [pdfHeading]

  const xlsxData = filteredData.map(elt => [
    elt.group,
    elt.name,
    elt.tags ? elt.tags.join(", ") : "",
    statusFormatterExport(elt.home),
    statusFormatterExport(elt.tracker),
    statusFormatterExport(elt.carephone),
    statusFormatterExport(elt.video),
    statusFormatterExport(elt.health),
    //statusFormatterExport(elt.dose),
    statusFormatterExport(elt.smartlock),
  ])

  const handlingInput = value => {
    let result = []
    result = series.filter(
      data =>
        data.group?.toLowerCase().includes(value) ||
        data.name?.toLowerCase().includes(value)
    )

    setFilteredData(result)

    // Set original data result if value ""
    if (value == "") {
      setFilteredData(series)
    }
  }

  // Handle search function
  const handleSearch = event => {
    let value = event.target.value.toLowerCase()
    setHandleValue(value)
    handlingInput(value)
  }

  function statusFormatter(cell, inActiveCell) {
    if (inActiveCell) {
      return (
        <span className="badge bg-secondary font-size-12">
          {props.t("Not active")}
        </span>
      )
    } else if (cell) {
      return (
        <span className="badge bg-success font-size-12">
          {props.t("In use")} <i className="bx bx-check"></i>
        </span>
      )
    } else {
      return (
        <span className="badge bg-danger font-size-12"></span> // HOX: Empty span
      )
    }
  }

  function statusFormatterExport(cell) {
    return cell ? props.t("x") : ""
  }

  return (
    <>
      <TableReporting
        origSeries={origSeries}
        setSeries={setSeries}
        title={title}
        columns={columns}
        seriesFiltered={filteredData}
        xlsxHeading={xlsxHeading}
        xlsxData={xlsxData}
        pdfHeading={pdfHeading}
        pdfData={pdfData}
        handleSearch={handleSearch}
        loading={loading}
        titleExport={titleExport}
      ></TableReporting>
    </>
  )
}

TableStats.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
}

export default withTranslation()(TableStats)
